import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
import useFormState from 'hooks/useFormState';
import { constants as loadConstants } from 'utils/loads';
// redux
import { useDispatch, useSelector } from 'react-redux';
import loadSelectors from 'state/loads/selectors';
import { actions as loadsActions } from 'state/loads';
// styles
import styled from 'styled-components';
// components
import Select from 'components/CustomSelect';
import { DropdownOption } from 'refactored/ui/form';

const NonPalletizedTypeDrodown = ({ className, shipmentKey, loadKey }) => {
  const { t } = useTranslation('loads');
  const dispatch = useDispatch();

  const load =
    useSelector((state) =>
      loadSelectors.getLoad(state, shipmentKey, loadKey)
    ) || {};

  const { BULK, PARCEL_CUSTOM, PARCEL_STANDART } =
    loadConstants.NON_PALLETIZED_TYPES;

  const {
    item_height: parcelHeight,
    item_length: parcelLength,
    item_width: parcelWidth,
  } = loadConstants.NON_PALLET_SIZES.PARCEL_STANDART;

  const isParcelPredifined =
    load.item_height === parcelHeight &&
    load.item_length === parcelLength &&
    load.item_width === parcelWidth;

  const isBulk = load?.load_type === loadConstants.LOAD_TYPES.BULK;
  const parcelType = isParcelPredifined ? PARCEL_STANDART : PARCEL_CUSTOM;
  const value = isBulk ? BULK : parcelType;

  const nonPalletizedTypes = loadConstants.NON_PALLETIZED_TYPES;
  const options = useMemo(
    () =>
      Object.keys(nonPalletizedTypes).map((key) => ({
        value: nonPalletizedTypes[key],
        label: t(`types_of_non_palletized_load.${nonPalletizedTypes[key]}`),
        subLabel:
          key !== BULK
            ? t(`types_of_non_palletized_sublabel.${nonPalletizedTypes[key]}`)
            : '',
      })),
    [BULK, nonPalletizedTypes, t]
  );

  const field = `load_type_of_goods`;
  const stopId = `${shipmentKey}-${loadKey}`;
  const { fieldHasError } = useFormState(stopId, field, value);
  const hasErrors = !!fieldHasError ? 'error' : 'not-error';

  const handleChange = ({ value: selectedValue }) => {
    dispatch(
      loadsActions.changeNonPalletType({
        shipmentKey,
        loadKey,
        value: selectedValue,
        field: loadConstants.FIELDS.LOAD_TYPE,
      })
    );
  };
  const showCustomLabel =
    load.item_length !== undefined &&
    load.item_width !== undefined &&
    load.item_height !== undefined;

  const customLabel = `(${load.item_length ? load.item_length : 0} 
    x ${load.item_width ? load.item_width : 0} 
    x ${load.item_height ? load.item_height : 0} cm)`;

  return (
    <div className={`${className} ${hasErrors}`} data-testid="pallet-type">
      <Select
        value={options.find((option) => option.value === value)}
        label={t('type_of_non_palletized_load')}
        subLabel={showCustomLabel && customLabel}
        placeholder={t('type_of_non_palletized_load')}
        options={options}
        isSearchable={false}
        onChange={handleChange}
        components={{ Option: DropdownOption }}
        dataE2E="select_load_type"
        t={t}
      />
    </div>
  );
};

NonPalletizedTypeDrodown.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  loadKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default styled(NonPalletizedTypeDrodown)`
  .sub-text {
    color: gray;
  }
`;
